/* Cotton Collective — Fit Comparison module. Added 2026-07-15.
   Renders the fit scale, worn-figure silhouettes, size toggle and size chart.
   Used by sections/cc-fit-comparison.liquid (product pages) and
   sections/cc-fit-guide.liquid (the /pages/fit-guide page).
   Product/fit data is embedded below — migrate to metafields later (see NOTES.md). */
(function () {
  "use strict";
  var SCALE = 4.4, FRAME_TOP = -11, FRAME_BOT = 34;
  var SIZES = ["XS","S","M","L","XL","XXL","3XL","4XL","5XL"];
  var COMPARE_SIZES = ["S","M","L","XL"];
  var FIT_TICKS = [{lab:"Standard",x:14},{lab:"Relaxed",x:40},{lab:"Boxy",x:66},{lab:"Cropped",x:90}];
  var ROWS = [
    {k:"bodyLen",lab:"Body length"},{k:"chest",lab:"Chest ½"},{k:"hem",lab:"Hem ½"},
    {k:"shoulder",lab:"Shoulder"},{k:"sleeve",lab:"Sleeve length"},
    {k:"sleeveCB",lab:"Sleeve (center-back)"},{k:"opening",lab:"Sleeve opening"},{k:"armhole",lab:"Armhole"},
    // bottoms rows (a product only renders the rows it has)
    {k:"waistHalf",lab:"Waist ½ (relaxed)"},{k:"hipHalf",lab:"Hip ½"},{k:"thighHalf",lab:"Thigh ½"},
    {k:"kneeHalf",lab:"Knee ½"},{k:"legOpen",lab:"Leg opening ½"},
    {k:"frontRise",lab:"Front rise"},{k:"backRise",lab:"Back rise"},
    {k:"inseam",lab:"Inseam"},{k:"outseam",lab:"Outseam"}
  ];

  var CATS = {
    hoodies: {
      name: "Hoodies", noun: "hoodie",
      sub: "Every Cotton Collective hoodie fit, drawn on the same body at one scale. All three are oversized drop-shoulder — Standard and Heavy share one Boxy pattern in two weights; Special is the longer, wider Relaxed cut.",
      items: [
        {h:"standard-hoodie-11oz",nm:"Standard",wt:"11 oz fleece",sku:"CCHOD376",fit:"Boxy",dot:62,hood:true,feat:"Oversized drop shoulder",
         sizes:["S","M","L","XL","XXL"],
         m:{bodyLen:[25,25.5,26,26.5,27],chest:[21.5,23,24.5,26,27.5],hem:[17.5,18.5,19.5,20.5,21.5],
            shoulder:[20,21.5,23,24.5,24.5],sleeve:[21.5,22,22.5,23,23.5],opening:[9.5,10.25,11,11.75,12.5],armhole:[11,11.5,12,12.5,13]}},
        {h:"heavy-hoodie-15oz",nm:"Heavy",wt:"15 oz fleece",sku:"CCHOD510",fit:"Boxy",dot:70,hood:true,feat:"Same cut as Standard Hoodie",
         sizes:["S","M","L","XL","XXL"],
         m:{bodyLen:[25,25.5,26,26.5,27],chest:[21.5,23,24.5,26,27.5],hem:[17.5,18.5,19.5,20.5,21.5],
            shoulder:[20,21.5,23,24.5,26],sleeve:[21.5,22,22.5,23,23.5],opening:[9.5,10.25,11,11.75,12.5],armhole:[11,11.5,12,12.5,13]}},
        {h:"special-hoodie-14oz",nm:"Special",wt:"14 oz fleece",sku:"CCHOD475",fit:"Relaxed",dot:40,hood:true,feat:"Longer body + wider",
         sizes:["XS","S","M","L","XL","XXL","3XL","4XL"],
         m:{bodyLen:[25,26,27,28,29,30,31,32],chest:[22,23.5,25,26.5,28,29.5,31,32.5],
            hem:[16.25,17.75,19.25,21.25,22.75,24.5,26.25,27.75],shoulder:[21.5,22.5,23.5,24.5,25.5,26.5,27.5,28.5],
            sleeve:[22.25,22.75,23.25,23.75,24.25,24.75,25.25,25.75],opening:[6.375,6.75,7.125,7.625,8,8.375,8.75,9.125],
            armhole:[8.75,9.25,9.75,10.25,10.75,11.25,11.75,12.25]}}
      ]
    },
    tees: {
      name: "T-Shirts", noun: "t-shirt",
      sub: "Daily and Tour are the Standard set-in-shoulder tees (Tour is the lighter 6.0 oz). Oversized Box is the Boxy dropped-shoulder cut; Oversized Crop is the same body cropped 2\". Drop Crop is wider and shorter still.",
      items: [
        {h:"tour-s-s-tee-6-0-oz",nm:"Tour",wt:"6.0 oz",sku:"CCSST200",fit:"Standard",dot:9,hood:false,feat:"Lightweight, closer fit",
         sizes:["S","M","L","XL","XXL","3XL","4XL","5XL"],
         m:{bodyLen:[28,29,30,31,32,33,34,35],chest:[18,20,22,24,26,28,30,32],sleeveCB:[15.125,16.5,18,19.5,21,22.375,23.625,25]}},
        {h:"daily-s-s-tee-6-5-oz",nm:"Daily",wt:"6.5 oz",sku:"CCSST220",fit:"Standard",dot:19,hood:false,feat:"Closer to body",
         sizes:["S","M","L","XL","XXL","3XL","4XL"],
         m:{bodyLen:[27.5,29,30.5,31.25,33,34.25,35.5],chest:[19,21,22.5,24.5,26,27.5,29],
            hem:[18.5,20.5,22,24,25.5,27,28.5],shoulder:[17,18.5,19.625,21.25,23,24.625,26.125],
            sleeve:[8,8.5,9,9.5,9.75,10,10.25],opening:[6.5,7,7.5,8,8.25,8.5,8.75],armhole:[8.5,9,9,9.5,10,10.5,11]}},
        {h:"oversized-box-s-s-tee-7-5-oz",nm:"Oversized Box",wt:"7.5 oz",sku:"CCSST250",fit:"Boxy",dot:60,hood:false,feat:"Dropped shoulder",
         sizes:["S","M","L","XL","XXL","3XL","4XL"],
         m:{bodyLen:[27.25,28.25,29.25,30.25,31.25,32.25,33.25],chest:[20.5,22,23.5,25,26.5,28,29.5],
            hem:[21.25,22.75,24.25,25.75,27.25,28.75,30.25],shoulder:[19.5,21,22.5,24,25.5,27,28.5],
            sleeve:[8.25,8.5,8.75,9,9.25,9.5,9.75],opening:[8.25,8.5,8.75,9,9.25,9.5,9.75],armhole:[9.5,10,10.5,11,11.5,12,12.5]}},
        {h:"oversized-crop-s-s-tee-7-5-oz",nm:"Oversized Crop",wt:"7.5 oz",sku:"CCCRP250",fit:"Cropped",dot:80,hood:false,feat:"Boxy body, cropped 2\"",
         sizes:["S","M","L","XL","XXL","3XL","4XL"],
         m:{bodyLen:[25.25,26.25,27.25,28.25,29.25,30.25,31.25],chest:[20.5,22,23.5,25,26.5,28,29.5],
            hem:[21.25,22.75,24.25,25.75,27.25,28.75,30.25],shoulder:[19.5,21,22.5,24,25.5,27,28.5],
            sleeve:[8.25,8.5,8.75,9,9.25,9.5,9.75],opening:[8.25,8.5,8.75,9,9.25,9.5,9.75],armhole:[9.5,10,10.5,11,11.5,12,12.5]}},
        {h:"drop-crop-s-s-tee-7-0-oz",nm:"Drop Crop",wt:"7 oz",sku:"CCDRP235",fit:"Cropped",dot:92,hood:false,feat:"Widest + shortest",
         sizes:["S","M","L","XL"],
         m:{bodyLen:[24,25,26,27],chest:[23,24,25,26],hem:[23.5,24.5,25.5,26.5],
            shoulder:[23,24,25,26],sleeve:[9.25,9.5,9.75,10],opening:[8,8.25,8.5,8.75],armhole:[9.5,10,10.5,11]}}
      ]
    },
    bottoms: {
      name: "Pants & Shorts", noun: "bottom",
      frame: { top: -4, bot: 47 },
      ticks: [{lab:"Standard",x:14},{lab:"Relaxed",x:42},{lab:"Baggy",x:74}],
      sub: "Both pants are full-length with elastic drawcord waists — Special is the tapered sweatpant, Baggy the wide straight leg. The shorts are cut roomy: Volley at a 6½\" inseam, Dunk the heavier 7\" cut.",
      lede: "Every Cotton Collective pant and short, drawn on the same lower body at one scale. You’re viewing this product — highlighted below. Tap another style to compare its cut and chart.",
      items: [
        {h:"special-pant-12-5-oz-wash",nm:"Special Pant",wt:"12.5 oz fleece",sku:"CCPNT420",fit:"Relaxed",dot:38,bottom:true,feat:"Tapered sweatpant",
         sizes:["S","M","L","XL","2XL","3XL"],
         m:{waistHalf:[13,14.25,15.5,17,18.5,20],hipHalf:[20.5,21.5,23,24.5,26,27.5],
            thighHalf:[13,13.5,14.25,15,15.75,16.5],kneeHalf:[8.375,8.75,9.125,9.5,9.875,10.25],
            legOpen:[7.75,8,8.25,8.5,8.75,9],frontRise:[12.5,13,13.5,14,14.5,15],
            backRise:[15,15.5,16,16.5,17,17.5],outseam:[40,40.5,41,41.5,42,42.5]}},
        {h:"baggy-pant-12-5-oz",nm:"Baggy Pant",wt:"12 oz fleece",sku:"CCPNT405",fit:"Baggy",dot:88,bottom:true,feat:"Widest leg, straight cut",
         sizes:["S","M","L","XL","2XL","3XL"],
         m:{waistHalf:[14,15,16,17,18,19],hipHalf:[22,23,24,25,26,27],
            thighHalf:[13.5,14,14.5,15,15.5,16],kneeHalf:[9.625,10,10.375,10.75,11.125,11.5],
            legOpen:[10.125,10.5,10.875,11.25,11.625,12],frontRise:[12,12.5,13,13.5,14,14.5],
            backRise:[17.5,18,18.5,19,19.5,20],outseam:[40.5,41,41.5,42,42.5,43]}},
        {h:"volley-short-12-5-oz",nm:"Volley Short",wt:"12.5 oz",sku:"CCVLY420",fit:"Baggy",dot:72,bottom:true,feat:"Athletic volume · 6½\" inseam",
         sizes:["S","M","L","XL","2XL","3XL"],
         m:{waistHalf:[15.5,16.75,18,19.25,20.25,21.25],hipHalf:[20,21.25,22.5,23.75,25,26.25],
            thighHalf:[12.375,13.125,13.875,14.625,15.375,16.125],legOpen:[10.875,11.375,11.875,12.375,12.875,13.375],
            frontRise:[10.875,11.5,12.125,12.75,13.375,14],backRise:[15.375,16,16.625,17.25,17.875,18.5],
            inseam:[6.5,6.5,6.5,6.5,6.5,6.5],outseam:[16.5,17,17.5,18,18.5,19]}},
        {h:"dunk-short-11-5-oz",nm:"Dunk Short",wt:"11.5 oz",sku:"CCSHR390",fit:"Relaxed",dot:58,bottom:true,feat:"Heavyweight · 7\" inseam",
         sizes:["S","M","L","XL","2XL"],
         m:{waistHalf:[12.5,13.5,14.5,15.5,16.5],hipHalf:[20.75,22,23.25,24.5,25.75],
            thighHalf:[13.25,13.75,14.25,14.75,15.25],legOpen:[11.125,11.5,11.875,12.25,12.625],
            frontRise:[11.5,12,12.5,13,13.5],backRise:[16,16.5,17,17.5,18],
            inseam:[7,7,7,7,7],outseam:[18,18.5,19,19.5,20]}}
      ]
    }
  };

  var KIDS = [
    {cc:"XS", std:"4 / 5",  age:"4–5 yrs",height:'40–44"',chest:'29½"'},
    {cc:"S",  std:"5 / 6",  age:"5–6 yrs",height:'44–47"',chest:'31"'},
    {cc:"M",  std:"6 / 7",  age:"6–7 yrs",height:'47–50"',chest:'32½"'},
    {cc:"L",  std:"7 / 8",  age:"7–8 yrs",height:'50–53"',chest:'34½"'},
    {cc:"XL", std:"10 / 12",age:"9–12 yrs",height:'54–58"',chest:'37"'},
    {cc:"2XL",std:"12 / 14",age:"12–14 yrs",height:'58–61"',chest:'39½"'}
  ];

  var S = SCALE;
  function P(x, y) { return (x * S).toFixed(1) + "," + (y * S).toFixed(1); }
  var MANNEQUIN = (function () {
    var head = '<ellipse class="cc-figure head" cx="0" cy="' + (-6.6 * S).toFixed(1) + '" rx="' + (3.0 * S).toFixed(1) + '" ry="' + (3.9 * S).toFixed(1) + '"/>';
    var neck = '<path class="cc-figure" d="M ' + P(-1.7,-2.9) + ' L ' + P(-1.7,-0.2) + ' M ' + P(1.7,-2.9) + ' L ' + P(1.7,-0.2) + '"/>';
    var armL = '<path class="cc-figure" d="M ' + P(-7.6,1.6) + ' Q ' + P(-10.8,10) + ' ' + P(-11,24.5) + '"/><circle class="cc-figure head" cx="' + (-11*S).toFixed(1) + '" cy="' + (26*S).toFixed(1) + '" r="' + (1.4*S).toFixed(1) + '"/>';
    var armR = '<path class="cc-figure" d="M ' + P(7.6,1.6) + ' Q ' + P(10.8,10) + ' ' + P(11,24.5) + '"/><circle class="cc-figure head" cx="' + (11*S).toFixed(1) + '" cy="' + (26*S).toFixed(1) + '" r="' + (1.4*S).toFixed(1) + '"/>';
    var legs = '<path class="cc-figure" d="M ' + P(-3.2,18) + ' L ' + P(-3.5,FRAME_BOT) + ' M ' + P(3.2,18) + ' L ' + P(3.5,FRAME_BOT) + '"/>';
    return { behind: head + neck, front: armL + armR + legs };
  })();

  // Lower-body mannequin for bottoms: waist sits at y=0, same 1 unit = 1 inch.
  var LOWER_MANNEQUIN = (function () {
    var torso = '<path class="cc-figure" d="M ' + P(-4.8,-4) + ' L ' + P(-4.5,0) + ' M ' + P(4.8,-4) + ' L ' + P(4.5,0) + '"/>';
    var legs = '<path class="cc-figure" d="M ' + P(-2.6,2) + ' L ' + P(-3.2,44) + ' M ' + P(2.6,2) + ' L ' + P(3.2,44) + '"/>';
    var feet = '<circle class="cc-figure head" cx="' + (-3.4*S).toFixed(1) + '" cy="' + (45.3*S).toFixed(1) + '" r="' + (1.4*S).toFixed(1) + '"/>'
             + '<circle class="cc-figure head" cx="' + (3.4*S).toFixed(1) + '" cy="' + (45.3*S).toFixed(1) + '" r="' + (1.4*S).toFixed(1) + '"/>';
    return { behind: torso, front: legs + feet };
  })();

  function sizeIndex(prod, sizeLabel) {
    var i = prod.sizes.indexOf(sizeLabel); if (i >= 0) return i;
    var want = SIZES.indexOf(sizeLabel), best = 0, bestd = 99;
    prod.sizes.forEach(function (s, idx) { var d = Math.abs(SIZES.indexOf(s) - want); if (d < bestd) { bestd = d; best = idx; } });
    return best;
  }

  // Bottoms silhouette: worn front view on the lower-body mannequin.
  // Chart values are FLAT widths (like the tops' "Chest ½"), so the drawn
  // half-extent is value/2. Legs are drawn as two columns with a crotch
  // split; knee width (when charted) shapes the taper so a tapered sweat
  // reads visibly slimmer than a wide straight leg.
  function bottomGarment(prod, si) {
    var m = prod.m;
    var wx = m.waistHalf[si] / 2;                       // half-extent at waist
    var hx = (m.hipHalf ? m.hipHalf[si] : m.waistHalf[si] + 6) / 2;
    var out = m.outseam[si];
    var rise = m.frontRise ? m.frontRise[si] : out * 0.3;
    var crotchY = m.inseam ? (out - m.inseam[si]) : Math.min(rise + 0.8, out - 4);
    var lo = m.legOpen ? m.legOpen[si] : hx * 0.9;      // one leg's flat width at hem
    var hipY = Math.min(rise * 0.72, crotchY - 1.2);
    var inTop = 0.6;                                    // inner edge x at crotch
    var hemC = Math.max(lo / 2 + 0.7, hx * 0.42);       // each leg's center x at hem
    var hemOut = hemC + lo / 2, hemIn = Math.max(0.35, hemC - lo / 2);
    var leftOuter, leftInner;
    if (m.kneeHalf && out - crotchY > 12) {             // full-length pant with knee data
      var kneeY = crotchY + (out - crotchY) * 0.45;
      var kw = m.kneeHalf[si] * 0.92;                   // one leg's drawn width at knee
      var kC = ((inTop + hx) / 2 + hemC) / 2;
      var kOut = kC + kw / 2, kIn = Math.max(0.35, kC - kw / 2);
      leftOuter = " L " + P(-kOut, kneeY) + " L " + P(-hemOut, out);
      leftInner = " L " + P(-hemIn, out) + " L " + P(-kIn, kneeY) + " L " + P(-inTop, crotchY + 0.3);
    } else {
      leftOuter = " L " + P(-hemOut, out);
      leftInner = " L " + P(-hemIn, out) + " L " + P(-inTop, crotchY + 0.3);
    }
    // one closed path, mirrored: down the left outer seam, left hem, up the
    // left inner seam to the crotch, down the right inner seam, right hem,
    // up the right outer seam, across the waist.
    var d = "M " + P(-wx, 0)
      + " Q " + P(-hx, hipY * 0.35) + " " + P(-hx, hipY)
      + leftOuter
      + leftInner
      + " Q " + P(0, crotchY - 0.7) + " " + P(inTop, crotchY + 0.3);
    if (m.kneeHalf && out - crotchY > 12) {
      var kneeY2 = crotchY + (out - crotchY) * 0.45;
      var kw2 = m.kneeHalf[si] * 0.92;
      var kC2 = ((inTop + hx) / 2 + hemC) / 2;
      d += " L " + P(Math.max(0.35, kC2 - kw2 / 2), kneeY2) + " L " + P(hemIn, out)
         + " L " + P(hemOut, out) + " L " + P(kC2 + kw2 / 2, kneeY2);
    } else {
      d += " L " + P(hemIn, out) + " L " + P(hemOut, out);
    }
    d += " L " + P(hx, hipY) + " Q " + P(hx, hipY * 0.35) + " " + P(wx, 0) + " Z";
    // waistband + drawcord detail
    var wbY = 1.7;
    var detail = '<path class="cc-gdetail" d="M ' + P(-wx + 0.15, wbY) + ' L ' + P(wx - 0.15, wbY) + '"/>'
      + '<path class="cc-gdetail" d="M ' + P(-1, wbY + 0.4) + ' L ' + P(-0.6, wbY + 2.6) + ' M ' + P(1, wbY + 0.4) + ' L ' + P(0.6, wbY + 2.6) + '"/>';
    var halfW = Math.max(hx, hemOut, wx, 12);
    return { inner: LOWER_MANNEQUIN.behind + LOWER_MANNEQUIN.front + '<path class="cc-garment" d="' + d + '"/>' + detail, halfW: halfW };
  }

  function garment(prod, si) {
    if (prod.bottom) return bottomGarment(prod, si);
    var m = prod.m, bodyLen = m.bodyLen[si], chest = m.chest[si];
    var shoulder = m.shoulder ? m.shoulder[si] : chest - 3;
    var arm = m.armhole ? m.armhole[si] : (prod.hood ? 11.5 : 10);
    var sleeve = m.sleeve ? m.sleeve[si] : (m.sleeveCB ? Math.max(6, m.sleeveCB[si] - shoulder / 2 - 1.5) : 9);
    var nh = 3.0, sh = shoulder / 2, ch = chest / 2, shDrop = 1.5, underY = arm, hemY = bodyLen, neckDip = 1.7;
    var sdx = Math.max(2.4, sleeve * 0.42), sdy = Math.max(3.2, sleeve * 0.6);
    var d = "M " + P(-nh,0) + " L " + P(-sh,shDrop) + " L " + P(-(sh+sdx),shDrop+sdy) + " L " + P(-ch,underY) + " L " + P(-ch,hemY)
      + " L " + P(ch,hemY) + " L " + P(ch,underY) + " L " + P((sh+sdx),shDrop+sdy) + " L " + P(sh,shDrop) + " L " + P(nh,0) + " Q " + P(0,neckDip) + " " + P(-nh,0) + " Z";
    var hood = "", detail = "";
    if (prod.hood) {
      var hw = nh + 2.3, hh = 4.8;
      hood = '<path class="cc-garment" d="M ' + P(-hw,shDrop) + ' C ' + P(-hw,-hh) + ' ' + P(-hw*0.4,-hh) + ' ' + P(0,-hh) + ' C ' + P(hw*0.4,-hh) + ' ' + P(hw,-hh) + ' ' + P(hw,shDrop) + ' Q ' + P(0,neckDip) + ' ' + P(-hw,shDrop) + ' Z"/>';
      var pw = ch * 0.6, pTop = hemY - 8.5, pBot = hemY - 1.6;
      detail = '<path class="cc-gdetail" d="M ' + P(-pw,pTop+1.2) + ' L ' + P(-pw*0.82,pTop) + ' L ' + P(pw*0.82,pTop) + ' L ' + P(pw,pTop+1.2) + ' L ' + P(pw,pBot) + ' L ' + P(-pw,pBot) + ' Z"/>';
    }
    var halfW = Math.max(sh + sdx, 12);
    return { inner: hood + MANNEQUIN.behind + MANNEQUIN.front + '<path class="cc-garment" d="' + d + '"/>' + detail, halfW: halfW };
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }

  function renderCategory(host, catKey, opts) {
    opts = opts || {};
    var cat = CATS[catKey]; if (!cat) return;
    var items = cat.items;
    var block = document.createElement("div");
    block.className = "cc-cat";
    var withHeading = !!opts.withHeading;
    var curH = opts.currentHandle && items.some(function (p) { return p.h === opts.currentHandle; }) ? opts.currentHandle : items[0].h;
    var state = { cur: curH, size: "L" };

    var fits = items.map(function (i) { return i.fit; }).filter(function (v, i, a) { return a.indexOf(v) === i; }).length;
    var headHtml = withHeading
      ? '<div class="cc-cat-head"><h2>' + esc(cat.name) + '</h2><span class="cc-idx">' + items.length + ' styles · ' + fits + ' fits</span></div>'
      : "";
    var lede = opts.lede || (withHeading ? cat.sub
      : (cat.lede || "Every Cotton Collective " + cat.noun + " fit, drawn on the same body at one scale. You’re viewing this product — highlighted below. Tap another style to compare its cut and chart."));

    block.innerHTML =
      headHtml +
      '<p class="cc-lede">' + lede + '</p>' +
      '<div class="cc-controls">' +
        '<div class="cc-ctl"><span class="cc-lbl">Style</span><div class="cc-pills" data-role="prod"></div></div>' +
        '<div class="cc-ctl"><span class="cc-lbl">Compare at size</span><div class="cc-pills" data-role="size"></div></div>' +
      '</div>' +
      '<div class="cc-scale"><div class="cc-track"></div></div>' +
      '<div class="cc-rack"></div>' +
      '<p class="cc-key">▸ every fit shown on the same body, one shared scale</p>' +
      '<div class="cc-chart-head"><h3></h3><span class="cc-sku"></span><span class="cc-measnote">measurements in inches, garment laid flat</span></div>' +
      '<div class="cc-tbl"><table></table></div>' +
      (opts.compareUrl ? '<a class="cc-compare" href="' + esc(opts.compareUrl) + '">See how all our fits compare — tees, kids &amp; more →</a>' : "");
    host.appendChild(block);

    var prodPills = block.querySelector('[data-role="prod"]');
    var sizePills = block.querySelector('[data-role="size"]');
    var track = block.querySelector(".cc-track");
    var rack = block.querySelector(".cc-rack");
    var h3 = block.querySelector(".cc-chart-head h3");
    var skuEl = block.querySelector(".cc-chart-head .cc-sku");
    var table = block.querySelector("table");
    rack.style.gridTemplateColumns = "repeat(" + items.length + ",1fr)";

    items.forEach(function (p) {
      var b = document.createElement("button");
      b.className = "cc-pill"; b.type = "button"; b.dataset.h = p.h;
      b.innerHTML = esc(p.nm) + (p.h === opts.currentHandle ? '<span class="cc-badge">• this</span>' : "");
      b.onclick = function () { state.cur = p.h; render(); };
      prodPills.appendChild(b);
    });
    COMPARE_SIZES.forEach(function (s) {
      var b = document.createElement("button");
      b.className = "cc-pill"; b.type = "button"; b.textContent = s; b.dataset.size = s;
      b.onclick = function () { state.size = s; render(); };
      sizePills.appendChild(b);
    });
    (cat.ticks || FIT_TICKS).forEach(function (t) {
      var el = document.createElement("div"); el.className = "cc-tick"; el.style.left = t.x + "%";
      el.innerHTML = '<div class="cc-tk"></div><div class="cc-tl">' + t.lab + "</div>"; track.appendChild(el);
    });

    function render() {
      prodPills.querySelectorAll(".cc-pill").forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.h === state.cur); });
      sizePills.querySelectorAll(".cc-pill").forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.size === state.size); });

      track.querySelectorAll(".cc-dot").forEach(function (n) { n.remove(); });
      items.forEach(function (p) {
        var dot = document.createElement("div"); dot.className = "cc-dot" + (p.h === state.cur ? " cur" : "");
        dot.style.left = p.dot + "%"; dot.title = p.nm; dot.onclick = function () { state.cur = p.h; render(); };
        if (p.h === state.cur) dot.innerHTML = '<div class="cc-flag">' + esc(p.nm) + (p.h === opts.currentHandle ? " · this page" : "") + "</div>";
        track.appendChild(dot);
      });

      var g = items.map(function (p) { var si = sizeIndex(p, state.size); return { p: p, si: si, g: garment(p, si) }; });
      var maxHalfW = Math.max.apply(null, g.map(function (o) { return o.g.halfW; }));
      var padX = 1.5;
      var fr = cat.frame || { top: FRAME_TOP, bot: FRAME_BOT };
      var vb = (-(maxHalfW + padX) * S).toFixed(1) + " " + (fr.top * S).toFixed(1) + " " + (2 * (maxHalfW + padX) * S).toFixed(1) + " " + ((fr.bot - fr.top) * S).toFixed(1);
      rack.innerHTML = "";
      g.forEach(function (o) {
        var p = o.p, si = o.si, shown = p.sizes[si];
        var cell = document.createElement("div");
        cell.className = "cc-figcell";
        var fig = document.createElement("button");
        fig.className = "cc-figbtn" + (p.h === state.cur ? " cur" : ""); fig.type = "button";
        fig.onclick = function () { state.cur = p.h; render(); };
        fig.innerHTML = (p.h === opts.currentHandle ? '<span class="cc-thistag">This page</span>' : '') +
          '<svg viewBox="' + vb + '" preserveAspectRatio="xMidYMin meet" role="img" aria-label="' + esc(p.nm) + ' at ' + shown + '">' + o.g.inner + "</svg>" +
          '<span class="cc-cap"><span class="cc-fitlab">' + esc(p.fit) + ' fit</span><span class="cc-nm">' + esc(p.nm) + '</span><span class="cc-wt">' + esc(p.wt) + '</span>' +
          '<span class="cc-feat">' + (p.h === state.cur ? "▸ " + esc(p.feat) : (shown !== state.size ? "shown " + shown : "")) + "</span></span>";
        cell.appendChild(fig);
        // product link under every mockup (skip on the product's own page)
        if (p.h !== opts.currentHandle) {
          var shop = document.createElement("a");
          shop.className = "cc-shop";
          shop.href = "/products/" + p.h;
          shop.textContent = "Shop " + p.nm + " →";
          cell.appendChild(shop);
        }
        rack.appendChild(cell);
      });

      var cur = items.filter(function (p) { return p.h === state.cur; })[0];
      h3.textContent = cur.nm + " — size chart";
      skuEl.textContent = cur.sku;
      var onCol = cur.sizes.indexOf(state.size);
      var head = "<thead><tr><th>Measurement</th>" + cur.sizes.map(function (s, i) { return '<th class="' + (i === onCol ? "on" : "") + '">' + s + "</th>"; }).join("") + "</tr></thead>";
      var body = "<tbody>" + ROWS.filter(function (r) { return cur.m[r.k]; }).map(function (r) {
        return "<tr><td>" + r.lab + "</td>" + cur.m[r.k].map(function (v, i) { return '<td class="' + (i === onCol ? "on" : "") + '">' + v + '"</td>'; }).join("") + "</tr>";
      }).join("") + "</tbody>";
      table.innerHTML = head + body;
    }
    render();
  }

  function renderKids(host) {
    var block = document.createElement("div"); block.className = "cc-cat";
    block.innerHTML =
      '<div class="cc-cat-head"><h2>Kids — Size Translator</h2><span class="cc-idx">kids products only</span></div>' +
      '<p class="cc-lede">Our kids sizing is our own. This translates it to the <b>standard US kids size</b> a parent already knows, by age and height. It runs roomy — pick your child’s everyday size and it’ll fit with room to grow.</p>' +
      '<p class="cc-kidsnote">Translated from our garment measurements (Oversized Kids Tee, CCSSK250).</p>' +
      '<div class="cc-tbl"><table></table></div>';
    host.appendChild(block);
    block.querySelector("table").innerHTML =
      '<thead><tr><th>Our size</th><th class="on">Standard US size</th><th>Approx age</th><th>Height</th><th>Garment chest</th></tr></thead><tbody>' +
      KIDS.map(function (k) {
        return "<tr><td>" + k.cc + '</td><td class="on">' + k.std + "</td><td>" + k.age + "</td><td>" + k.height + "</td><td>" + k.chest + "</td></tr>";
      }).join("") + "</tbody>";
  }

  function init(root) {
    if (root.dataset.ccReady) return; root.dataset.ccReady = "1";
    var mode = root.dataset.mode || "product";
    var host = root.querySelector("[data-cc-host]") || root;
    if (mode === "guide") {
      Object.keys(CATS).forEach(function (k) { renderCategory(host, k, { withHeading: true }); });
      renderKids(host);
      root.hidden = false; // guide roots may also start hidden
      return;
    }
    var category = root.dataset.category || "auto";
    var handle = root.dataset.handle || "";
    if (category === "auto" || !CATS[category]) {
      category = Object.keys(CATS).filter(function (k) {
        return CATS[k].items.some(function (p) { return p.h === handle; });
      })[0];
    }
    if (!category) {
      // kids products get the size translator instead of a fit comparison
      var KIDS_HANDLES = ["oversized-kids-s-s-tee-7-5-oz", "oversized-kids-2fer-l-s-tee-7-5-oz"];
      if (KIDS_HANDLES.indexOf(handle) !== -1) {
        renderKids(host);
        var thin = root.querySelector(".cc-ttl .thin");
        if (thin) thin.textContent = "— Kids size translator";
        root.hidden = false;
        return;
      }
      root.hidden = true;
      if (window.console) console.warn("CCFit: no fit data for product handle '" + handle + "' — module hidden.");
      return;
    }
    renderCategory(host, category, { currentHandle: handle, compareUrl: root.dataset.compareUrl });
    root.hidden = false;
  }

  window.CCFit = { init: init };
  function boot() { document.querySelectorAll(".cc-fit[data-cc-init]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
